module.exports = __webpack_public_path__ + "static/other/starHauler.7b7d1633.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/starHauler.json
// module id = 2218
// module chunks = 0